/**
 * Return HTML node
 * @return {element}
 */
export function getHtml () {
    return document.getElementsByTagName('html')[0]
}

/**
 * Add event to element
 * @param obj
 * @param type
 * @param fn
 */
export function addEvent (obj, type, fn) {
    if (obj.addEventListener) {
        obj.addEventListener(type, fn, false)
    } else if (obj.attachEvent) {
        if (type === 'scroll') {
            type = 'mousewheel'
        }

        obj['e' + type + fn] = fn
        obj[type + fn] = function () {
            obj['e' + type + fn](window.event)
        }
        obj.attachEvent('on' + type, obj[type + fn])
    } else {
        obj['on' + type] = obj['e' + type + fn]
    }
}

/**
 * Remove event to element
 * @param obj
 * @param type
 * @param fn
 */
export function deleteEvent (obj, type, fn) {
    if (obj.removeEventListener) {
        obj.removeEventListener(type, fn, false)
    } else if (obj.detachEvent) {
        if (type === 'scroll') {
            type = 'mousewheel'
        }

        obj['e' + type + fn] = fn
        obj[type + fn] = function () {
            obj['e' + type + fn](window.event)
        }
        obj.detachEvent('on' + type, obj[type + fn])
    } else {
        obj['on' + type] = obj['e' + type + fn]
    }
}

/**
 * Add event once to element
 * @param obj
 * @param type
 * @param fn
 */
export function addEventOnce (obj, type, fn) {
    const eventHandler = (e) => {
        deleteEvent(obj, type, eventHandler)
        fn(e)
    }

    addEvent(obj, type, eventHandler)

    return eventHandler
}
